import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { entriesFromTemplateVars } from "@/utils/templateVars";

type TemplateVarsCellProps = {
  templateVars: unknown;
};

/** Click "View" to open a popover listing template merge fields. */
export function TemplateVarsCell({ templateVars }: TemplateVarsCellProps) {
  const tvRows = entriesFromTemplateVars(templateVars);
  const tvCount = tvRows.length;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="inline-flex cursor-pointer items-center border-none bg-transparent p-0 text-xs font-medium text-primary-dark underline-offset-2 hover:text-blue-700"
          aria-label={`View ${tvCount} template variable${tvCount === 1 ? "" : "s"}`}
        >
          View
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        side="left"
        className="max-w-2xl border border-gray-200 bg-white p-3 text-gray-900 shadow-sm"
      >
        {tvCount === 0 ? (
          <span className="text-xs text-gray-500">No template variables</span>
        ) : (
          <div className="flex max-h-64 max-w-md flex-col gap-1 overflow-y-auto text-left">
            {tvRows.map((row) => (
              <div key={row.label} className="text-xs leading-snug text-gray-800">
                <span className="text-gray-600 capitalize">{row.label}:</span>{" "}
                <span className="wrap-break-word text-gray-900">{row.value}</span>
              </div>
            ))}
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}
